import FixedDelayTokenRefillStrategy from "./FixedDelayTokenRefillStrategy";
import TokenRefillStrategy from "./TokenRefillStrategy";

export default class FixedDelayTokenRefillStrategyFactory {
    public static create(
        delayInMilliseconds: number
    ): TokenRefillStrategy {
        return new FixedDelayTokenRefillStrategy(delayInMilliseconds);
    }
}